// This file is generated by scripts/fetch-bitcraft-data.ts.
// Keep committed so GitHub Pages can build without a backend.

export const bitcraftSnapshot = {
  "provenance": {
    "fetchedAt": "2026-05-08T13:15:18.383Z",
    "notes": "Generated from manually fetched Bitjita API responses and BitCraft Map GeoJSON exports. Runtime UI can refresh Bitjita data from the browser; backend writes are reserved for a future SpaceTimeDB module.",
    "sources": [
      "https://bitjita.com/api/items",
      "https://bitjita.com/api/resources",
      "https://bitjita.com/api/buildings",
      "https://bitjita.com/api/creatures",
      "https://exports.bitjita.com/bitcraftmap/claims.geojson",
      "https://exports.bitjita.com/bitcraftmap/caves.geojson",
      "https://exports.bitjita.com/bitcraftmap/temples.geojson",
      "https://exports.bitjita.com/bitcraftmap/ruined.geojson",
      "https://exports.bitjita.com/bitcraftmap/dungeons.geojson",
      "https://exports.bitjita.com/bitcraftmap/trees.geojson",
      "https://exports.bitjita.com/bitcraftmap/towers.geojson",
      "https://exports.bitjita.com/bitcraftmap/grids.geojson"
    ]
  },
  "bitjita": {
    "items": {
      "count": 7281,
      "endpoint": "/api/items"
    },
    "resources": {
      "count": 510,
      "endpoint": "/api/resources"
    },
    "buildings": {
      "count": 934,
      "endpoint": "/api/buildings"
    },
    "creatures": {
      "count": 41,
      "endpoint": "/api/creatures"
    }
  },
  "map": {
    "claims": {
      "count": 1560,
      "samples": [
        "Lavendell Forest",
        "Claimed area (N: 6366, E: 8067)",
        "Pipou City",
        "CASTAWAHS THE WAHING"
      ]
    },
    "caves": {
      "count": 2975,
      "samples": [
        "Large Luminite Cave (N: 7847, E: 4423)",
        "Large Pyrelite Cave (N: 7918, E: 4074)",
        "Large Ferralith Cave (N: 7942, E: 2782)",
        "Large Pyrelite Cave (N: 7961, E: 4159)"
      ]
    },
    "temples": {
      "count": 34,
      "samples": [
        "Third Temple Entrance (N: 3151, E: 3082)",
        "Fourth Temple Entrance (N: 3535, E: 4781)",
        "First Temple Entrance (N: 3745, E: 3857)",
        "Second Temple Entrance (N: 4337, E: 2833)"
      ]
    },
    "ruinedCities": {
      "count": 32,
      "samples": [
        "Rimefield",
        "Shardvale",
        "Marrowick",
        "Ravenmoor"
      ]
    },
    "dungeons": {
      "count": 88,
      "samples": []
    },
    "hexiteDeposits": {
      "count": 95,
      "samples": [
        "Hexite Deposit (N: 3014, E: 4142)",
        "Hexite Deposit (N: 4555, E: 2820)",
        "Hexite Deposit (N: 4598, E: 3471)",
        "Hexite Deposit (N: 3362, E: 3687)"
      ]
    },
    "watchtowers": {
      "count": 1431,
      "samples": [
        "Watchtower (N: 8773, E: 3494)",
        "Watchtower (N: 8773, E: 3494)",
        "Watchtower (N: 8227, E: 2724)",
        "Watchtower (N: 8227, E: 2724)"
      ]
    },
    "grids": {
      "count": 11,
      "samples": []
    }
  },
  "records": [
    {
      "id": "2098653797",
      "kind": "item",
      "name": "Abyssal Gladius Experiment",
      "tier": 9,
      "tag": "Experimentation",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "61508445",
      "kind": "item",
      "name": "Abyssal Gladius Filet",
      "tier": 9,
      "tag": "Oceanfish Filet",
      "description": "A filet from a fish from the ocean. Could be used to make food.",
      "source": "Bitjita API"
    },
    {
      "id": "582205174",
      "kind": "item",
      "name": "Abyssal Gladius Products",
      "tier": 9,
      "tag": "Oceanfish Products",
      "description": "Filets of fish from an Ocean Fish. Can also provide Fish Oil or Scales.",
      "source": "Bitjita API"
    },
    {
      "id": "204941440",
      "kind": "item",
      "name": "Abyssal Gladius Scale",
      "tier": 9,
      "tag": "Oceanfish Scale",
      "description": "A fish scale crystalized by the salt in the ocean. Svim would be interested in this.",
      "source": "Bitjita API"
    },
    {
      "id": "1831764501",
      "kind": "item",
      "name": "Abyssal Nobilis",
      "tier": 9,
      "tag": "Lake Fish",
      "description": "A fish found in the deeper parts of lakes and some rivers. Can provide fish oil, food and also be used as chum for ocean fishing.",
      "source": "Bitjita API"
    },
    {
      "id": "1928401049",
      "kind": "item",
      "name": "Abyssal Nobilis Experiment",
      "tier": 9,
      "tag": "Experimentation",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "1507337921",
      "kind": "item",
      "name": "Abyssal Nobilis Filet",
      "tier": 9,
      "tag": "Lake Fish Filet",
      "description": "A filet from a fish from the deeper parts of a lake. Could be used for food or to make fertilizer for farming.",
      "source": "Bitjita API"
    },
    {
      "id": "467423428",
      "kind": "item",
      "name": "Abyssal Nobilis Products",
      "tier": 9,
      "tag": "Lake Fish Products",
      "description": "Filets of fish from a Lake Fish. Can also provide Fish Oil.",
      "source": "Bitjita API"
    },
    {
      "id": "6110004",
      "kind": "resource",
      "name": "Abyssal Oyster",
      "tier": 6,
      "tag": "Mollusks",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "756579517",
      "kind": "resource",
      "name": "Abyssal Rasbi",
      "tier": 9,
      "tag": "Baitfish",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "207",
      "kind": "resource",
      "name": "Advanced Door",
      "tier": 6,
      "tag": "Obstacle",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "203",
      "kind": "resource",
      "name": "Advanced Key Pedestal",
      "tier": 6,
      "tag": "Obstacle",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "93",
      "kind": "resource",
      "name": "Aloe",
      "tier": 3,
      "tag": "Flower",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "849939303",
      "kind": "resource",
      "name": "Alpha Jakyl Puppy Den",
      "tier": -1,
      "tag": "Monster Den",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "185",
      "kind": "resource",
      "name": "Ancient Adventurer's Letter",
      "tier": 1,
      "tag": "Note",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "194",
      "kind": "resource",
      "name": "Ancient Adventurer's Note",
      "tier": 2,
      "tag": "Note",
      "description": "",
      "source": "Bitjita API"
    },
    {
      "id": "1130862882",
      "kind": "building",
      "name": "Alesi's Hideout",
      "tier": 0,
      "tag": "buildings",
      "description": "The atrium of an ancient library",
      "source": "Bitjita API"
    },
    {
      "id": "846734170",
      "kind": "building",
      "name": "Alpha Jakyl Dungeon",
      "tier": 0,
      "tag": "buildings",
      "description": "Ancient Ruins",
      "source": "Bitjita API"
    },
    {
      "id": "1615467546",
      "kind": "building",
      "name": "Ancient Bank",
      "tier": 0,
      "tag": "buildings",
      "description": "A bank which has a personal inventory for each player",
      "source": "Bitjita API"
    },
    {
      "id": "1957138389",
      "kind": "building",
      "name": "Ancient Carpentry Station",
      "tier": 0,
      "tag": "buildings",
      "description": "A workstation for making various tools, vehicles and materials out of planks.",
      "source": "Bitjita API"
    },
    {
      "id": "1109338245",
      "kind": "building",
      "name": "Ancient Cooking Station",
      "tier": 0,
      "tag": "buildings",
      "description": "A worksurface for preparing foods",
      "source": "Bitjita API"
    },
    {
      "id": "1463064351",
      "kind": "building",
      "name": "Ancient Crude Workbench",
      "tier": 0,
      "tag": "buildings",
      "description": "A crude worksurface for crafting basic tools.",
      "source": "Bitjita API"
    },
    {
      "id": "1441436391",
      "kind": "building",
      "name": "Ancient Crumbled Pillar",
      "tier": 0,
      "tag": "buildings",
      "description": "Ancient Ruins",
      "source": "Bitjita API"
    },
    {
      "id": "1842388176",
      "kind": "building",
      "name": "Ancient Crumbled Platform",
      "tier": 0,
      "tag": "buildings",
      "description": "Ancient Ruins",
      "source": "Bitjita API"
    },
    {
      "id": "18",
      "kind": "creature",
      "name": "Alpha Jakyl",
      "tier": 1,
      "tag": "Monster",
      "description": "A massive Jakyl. Much stronger than the others you've seen. These animals will avoid light sources.",
      "source": "Bitjita API"
    },
    {
      "id": "27",
      "kind": "creature",
      "name": "Alpha Umbura",
      "tier": 1,
      "tag": "Monster",
      "description": "A massive, aggressive creature. This creature looks tougher than other Umburas you've seen. Particularly aggressive at night. This creature will avoid light sources in player made towns.",
      "source": "Bitjita API"
    },
    {
      "id": "40",
      "kind": "creature",
      "name": "Araknir Nest",
      "tier": 1,
      "tag": "Monster",
      "description": "A spider nest which is protected by the spiders in the cave.",
      "source": "Bitjita API"
    },
    {
      "id": "4",
      "kind": "creature",
      "name": "Ardea",
      "tier": 4,
      "tag": "Huntable Animal",
      "description": "An animal which can be hunted by a hunter with the appropriate bow. Once killed, the animal can be brought to a hunter's workstation where it can be processed into hides, meat and rarely animal fur.",
      "source": "Bitjita API"
    },
    {
      "id": "37",
      "kind": "creature",
      "name": "Cave Skitch",
      "tier": 1,
      "tag": "Monster",
      "description": "A skitch that has lived underground for quite some time. It seems to have made itself some armor out of metal that was laying around.",
      "source": "Bitjita API"
    },
    {
      "id": "21",
      "kind": "creature",
      "name": "Desert Crab",
      "tier": 1,
      "tag": "Monster",
      "description": "A strange creature that hides under a rock hard shell. Not particularly threatening by itself but its friends are always nearby.",
      "source": "Bitjita API"
    },
    {
      "id": "16",
      "kind": "creature",
      "name": "Desert Terrorbird",
      "tier": 10,
      "tag": "Huntable Animal",
      "description": "An animal which can be hunted by a hunter with the appropriate bow. Once killed, the animal can be brought to a hunter's workstation where it can be processed into hides, meat and rarely animal fur.",
      "source": "Bitjita API"
    },
    {
      "id": "3",
      "kind": "creature",
      "name": "Dromai",
      "tier": 5,
      "tag": "Huntable Animal",
      "description": "An animal which can be hunted by a hunter with the appropriate bow. Once killed, the animal can be brought to a hunter's workstation where it can be processed into hides, meat and rarely animal fur.",
      "source": "Bitjita API"
    }
  ]
} as const;

export type BitcraftSnapshot = typeof bitcraftSnapshot;
export type BitcraftSnapshotRecord = (typeof bitcraftSnapshot.records)[number];
